import { configureStore } from "@reduxjs/toolkit";

// Reducers
import { viewsReducer } from "./reducers";

// Slices
import signedInUserReducer from "./signedInUserSlice";
import signedKeyReducer from "./signedKeySlice";
import signKeyFormReducer from "./signKeyFormSlice";

// Services
import { signKeyApi, usersApi, profilesApi, auditEntriesApi } from "./services/api";

export const makeStore = () =>
  configureStore({
    reducer: {
      views: viewsReducer,
      signedInUser: signedInUserReducer,
      signKeyForm: signKeyFormReducer,
      signedKey: signedKeyReducer,
      [usersApi.reducerPath]: usersApi.reducer,
      [signKeyApi.reducerPath]: signKeyApi.reducer,
      [profilesApi.reducerPath]: profilesApi.reducer,
      [auditEntriesApi.reducerPath]: auditEntriesApi.reducer,
    },
    devTools: process.env.NODE_ENV === "development",
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredPaths: ["signKeyForm.username", "signKeyForm.sourceAddress", "signKeyForm.ttl"]
        }
      }).concat(usersApi.middleware, signKeyApi.middleware, profilesApi.middleware, auditEntriesApi.middleware),
  });

const store = makeStore();

export type AppState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;

export default store;
